(function () {
  // Shared formatting helpers on the window.Allvar namespace.
  //
  // Load before any script that formats prices client-side.
  window.Allvar = window.Allvar || {};

  // Format a subunit amount (öre/cents) the way Liquid's `money` filter does.
  //
  // The store's money format renders whole kronor ("350 kr"). Intl defaults to
  // two decimals, so a server-rendered price visibly gained ",00" the moment JS
  // re-rendered it — the shift this function exists to remove. Whole kronor also
  // convert better: shorter price strings are perceived as smaller, and Nordic
  // retail convention omits öre.
  //
  // Decimals are kept when the amount genuinely has öre. That case is real: a
  // 15% multi-buy tier on 350 kr × 3 is 892,50. Forcing 0 decimals would render
  // "893 kr" — 50 öre MORE than the shopper is charged — so whole amounts drop
  // the decimals and fractional ones keep them honest.
  //
  // @param {number} cents - Amount in currency subunits
  // @param {object} [opts] - { locale, currency }; both default to the document
  //   language and SEK. Callers holding their own resolved values pass them in.
  // @returns {string} e.g. "350 kr", "1 190 kr", "892,50 kr"
  window.Allvar.money = function (cents, opts) {
    const o = opts || {};
    const amount = Number(cents) || 0;
    const digits = amount % 100 === 0 ? 0 : 2;
    return new Intl.NumberFormat(o.locale || document.documentElement.lang || 'sv', {
      style: 'currency',
      currency: o.currency || 'SEK',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(amount / 100);
  };
})();
